import { currencies } from "../content/currencies";
export var getCurrency = function getCurrency(code) {
  var _currencies$find;
  return (_currencies$find = currencies.find(function (currency) {
    return currency.code === code;
  })) !== null && _currencies$find !== void 0 ? _currencies$find : null;
};